import { PaymentsCreateOrderAttributes, PaymentsProduct } from "~/api/Api";

import { Icon } from "../../../assets/icons/Icon";
import { FeatureSection } from "../featureSection/FeatureSection";
import { PricingCard } from "../pricingCard/PricingCard";
import styles from "./NicheLinksPackage.module.scss";

interface NicheLinksPackageProps {
  product: PaymentsProduct;
  targetSites: { value: string; label: string }[];
  createOrder: (order: PaymentsCreateOrderAttributes) => void;
}
const descriptionList = (value: string | null) => [
  `${value} Authority Links`,
  `Strengthen your site's authority in your market`,
  `${value} targeted, relevant link placements`,
  `Topically aligned backlinks`,
  `60 Day Delivery`,
];
const text2 = [
  {
    title: "Select the right plan",
    description: `Choose the package that best fits your site and objectives. Once your order is placed, our team will begin preparing your Authority campaign.`,
  },
  {
    title: "We execute the campaign",
    description: `Our team reviews the target opportunities, determines the appropriate acquisition path, and carries out the required work to secure relevant placements. If any additional input is needed, we'll contact you directly.`,
  },
  {
    title: "Track delivery in your dashboard",
    description: `Completed placements are added to your dashboard as they are delivered. Most campaigns are completed within 60 days, and we'll notify you when your order is finished.`,
  },
];
export const NicheLinksPackage = ({
  product,
  targetSites,
  createOrder,
}: NicheLinksPackageProps) => {
  return (
    <div className={styles.nicheLinksPackage}>
      {/* Hero/Sales Section - First to hook visitors */}
      <div className={styles.heroSection}>
        <section className={styles.descriptionCard}>
          <div className={styles.descriptionWrapper}>
            <h3 className={styles.descriptionTitle}>
              We'll Build Your Authority Links for You
            </h3>
            <div className={styles.descriptionContent}>
              <div className={styles.nicheLinksImage}>
                <Icon
                  iconName="NicheLinksImage"
                  width="19.125rem"
                  height="12.5rem"
                />
              </div>

              <div className={styles.descriptionTextContainer}>
                <p className={styles.descriptionText}>
                  Authority links help strengthen your website's authority and
                  topical relevance through placements on established, relevant
                  websites.
                </p>
                <p className={styles.descriptionText}>
                  Our team identifies the right opportunities, executes the
                  required outreach or placement process, and tracks delivery
                  through completion.
                </p>
                <p className={styles.descriptionText}>
                  This allows your team to expand search visibility and build
                  stronger external authority without taking on the manual work
                  internally.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Pricing Section */}
      <div className={styles.pricingSection}>
        <div className={styles.pricingCards}>
          {product.prices
            ?.sort((a, b) => a.amount - b.amount)
            .map((price) => (
              <PricingCard
                key={price.id}
                createOrder={createOrder}
                price={price}
                targetSites={targetSites}
                list={descriptionList(price.size)}
              />
            ))}
        </div>
      </div>

      {/* How it Works Section */}
      <div>
        <FeatureSection
          title="How it works"
          icon="BrandLinksImage2"
          text={text2}
          reversed
        />
      </div>
    </div>
  );
};
